import { useCallback, useEffect } from 'react'

import { type ContactFormState } from '../../contact-form'
import { useUserApiSwrSessionV1Customer } from '../../user-data'
import { useDirectFormDialogContext } from '../components/DirectContactFormDialog/DirectContactFormDialogContext'

export const useDirectContactFormUpdateFormStateWithUserData = (
  formState: ContactFormState,
): void => {
  const { userData } = useDirectFormDialogContext()
  const { data: userPersonalData } = useUserApiSwrSessionV1Customer()
  const isLoggedIn = Boolean(userPersonalData?.customerNumber)

  const setFormValues = useCallback(
    (data: {
      email?: string
      firstName?: string
      lastName?: string
      phone?: string
    }): void => {
      if (data.firstName) {
        formState.setValue(data.firstName, formState.model, 'firstName')
      }
      if (data.lastName) {
        formState.setValue(data.lastName, formState.model, 'lastName')
      }
      if (data.email) {
        formState.setValue(data.email, formState.model, 'email')
      }
      if (data.phone) {
        formState.setValue(data.phone, formState.model, 'phoneNumber')
      }
    },
    [formState],
  )

  useEffect(() => {
    if (isLoggedIn) {
      const phone =
        userData.phone === '' ? userPersonalData?.phone : userData.phone
      setFormValues({
        email: userPersonalData?.email,
        firstName: userPersonalData?.firstName,
        lastName: userPersonalData?.lastName,
        phone,
      })
    }
    if (!isLoggedIn) {
      setFormValues({
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        phone: userData.phone,
      })
    }
  }, [formState, isLoggedIn, setFormValues, userData, userPersonalData])
}
